
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InitializeCashReports"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pointOfSale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeAllPaymentMethods"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"EX_POS_InitializeCashReports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pointOfSale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pointOfSale"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeAllPaymentMethods"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeAllPaymentMethods"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"should"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"use_denomination"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"denominations"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coins"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"notes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"period_starts_at"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"period_ends_at"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currency_code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"payment_method_service"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"payment_method_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"administrator_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"point_of_sale_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currency"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"iso4217"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sign"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"service"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"digital"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"position"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"default"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":916}};
    doc.loc.source = {"body":"query InitializeCashReports($pointOfSale: Int!, $includeAllPaymentMethods: Boolean) {\n    EX_POS_InitializeCashReports(pointOfSale: $pointOfSale, includeAllPaymentMethods: $includeAllPaymentMethods) {\n        uuid\n        should\n        is\n        use_denomination\n        denominations {\n            coins {\n                count\n                value\n            }\n            notes {\n                count\n                value\n            }\n        }\n        # comment\n        period_starts_at\n        period_ends_at\n        currency_code\n        payment_method_service\n        payment_method_name\n        administrator_name\n        point_of_sale_name\n        currency {\n            id\n            iso4217\n            sign\n        }\n        paymentMethod {\n            id\n            name\n            description\n            service\n            digital\n            position\n            default\n        }\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["InitializeCashReports"] = oneQuery(doc, "InitializeCashReports");
        
